var _defs, _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_4740454a8698098e3d662642efb2ff9567fcf2f8cd04f9998f7185ef92ae9d3c",
    x1: 46.4,
    y1: 39.13,
    x2: 63.75,
    y2: 39.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M45.233 28.372h5.89M45.233 32.362h3.569M45.233 36.09h2.674M31.906 28.372h5.89M31.906 32.362h5.89M31.906 36.09h5.89M45.233 39.972h3.196M45.233 43.699h5.135M31.906 39.972h5.89M31.906 43.699h5.89M41.81 24.028v23.588M30.146 17.791h23.327v5.907H30.146zM23.698 17.886h-8.105V10.25c0-2.153 1.825-3.916 4.05-3.916s4.055 1.762 4.055 3.916v7.636z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M60.214 48.511v11.207H23.681l.017-41.832M19.645 6.282h36.514c2.23 0 4.055 1.763 4.055 3.914V24.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 59.702,
    cy: 36.721,
    r: 11.566
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M68.62 48.532l2.894-2.893 9.92 9.92-2.893 2.894zM67.902 45.055l2.01 1.803"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M67.374 40.248a8.44 8.44 0 11-15.309-7.113",
    stroke: "url(#SVGID_0_4740454a8698098e3d662642efb2ff9567fcf2f8cd04f9998f7185ef92ae9d3c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountAnalysis);
export default __webpack_public_path__ + "static/media/accountAnalysis.1c03434706794df9326f9896e05e2822.svg";
export { ForwardRef as ReactComponent };